import React from 'react'
import { Button } from 'antd'
import { Settings2 } from 'lucide-react'
import type { LineItem } from '../../types/ffe'
import { useFFEStore } from '../../store/ffeStore'

interface Props {
  itemId: LineItem['id']
  className?: string
  disabled?: boolean
}

export const MaterialsButton: React.FC<Props> = ({
  itemId,
  className,
  disabled
}) => {
  const setLineItemDetailsDrawerId = useFFEStore(
    (state) => state.setLineItemDetailsDrawerId
  )
  return (
    <>
      <Button
        disabled={disabled}
        className={className}
        icon={<Settings2 className="h-4 w-4" />}
        onClick={() => setLineItemDetailsDrawerId(itemId)}
      >
        Details
      </Button>
    </>
  )
}
